import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useSalesContext } from "../../Pages/SalesContext";
import SalesTrendHeader from "../../Pages/SalesTrendHeader";
import LeadershipdataComp from "./components/LeadershipdataComp";
import LeadershipTable from "./components/LeadershipTable";
import { API_BASE_URL } from "../../config/config";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";
interface DecodedToken {
  name: string;
  preferred_username: string;
}

// const saveTokenWithExpiry = (token: string, expiryDays = 1) => {
//   const now = Date.now();
//   const expiry = now + expiryDays * 24 * 60 * 60 * 1000;
//   localStorage.setItem(
//     "access_token",
//     JSON.stringify({ value: token, expiry })
//   );
// };

// const getValidToken = () => {
//   const item = localStorage.getItem("access_token");
//   if (!item) return null;

//   try {
//     const { value, expiry } = JSON.parse(item);
//     if (Date.now() > expiry) {
//       console.warn("Token expired, removing from storage.");
//       localStorage.removeItem("access_token");
//       return null;
//     }
//     return value;
//   } catch (e) {
//     console.error("Error parsing token:", e);
//     localStorage.removeItem("access_token");
//     return null;
//   }
// };

// const LeadershipDashboardmflm: React.FC = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { setKpiData } = useSalesContext();

//   const [userLocation, setUserLocation] = useState<string | null>(null);
//   const [headerUsername, setHeaderUsername] = useState<string | null>(null);
//   const [userdata, setUserData] = useState<any>(null);
//   const [refreshTime, setRefreshTime] = useState<string>();

//   // Handle token from query string (on first load)
//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const queryToken = queryParams.get("access_token");

//     if (queryToken) {
//       saveTokenWithExpiry(queryToken);
//       console.log("Token from URL:", queryToken);
//       navigate("/app/kpi_leadership_dashboard_FLM", { replace: true });
//     }
//   }, [location, navigate]);

//   const token = getValidToken();

//   useEffect(() => {
//     if (!token) return;

//     let user_id = "";
//     try {
//       const decoded = jwtDecode<DecodedToken>(token);
//       user_id = decoded?.preferred_username || "";
//       console.log("Decoded Token:", decoded);
//     } catch (e) {
//       console.error("Invalid token", e);
//     }

//     fetch(`${API_BASE_URL}User/UserDetails`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setUserData(data.data);
//         setUserLocation(data.data?.user_Location || null);
//         setHeaderUsername(data.data?.username || null);

//         // Format refresh time to IST
//         const rawTime = data?.data?.last_Refresh_Time;
//         if (rawTime) {
//           const timeWithoutZ = rawTime.endsWith("Z")
//             ? rawTime.slice(0, -1)
//             : rawTime;

//           let istTime = new Date(timeWithoutZ).toLocaleString("en-IN", {
//             timeZone: "Asia/Kolkata",
//             year: "numeric",
//             month: "numeric",
//             day: "numeric",
//             hour: "numeric",
//             minute: "numeric",
//             second: "numeric",
//             hour12: true,
//           });

//           istTime = istTime.replace("am", "AM").replace("pm", "PM");
//           setRefreshTime(istTime);
//         }
//       })
//       .catch((err) => {
//         console.error("Failed to fetch user details:", err);
//       });
//   }, [location, navigate]);

//   return (
//     <div className="sales-trend-dashboard">
//       <div className="dashboard-container">
//         <SalesTrendHeader
//           title="KPI Dashboard"
//           userName={headerUsername}
//           location={userLocation}
//           refreshTime={refreshTime}
//         />
//         <LeadershipdataComp />
//         <LeadershipTable userData={userdata} />
//       </div>
//     </div>
//   );
// };

// export default LeadershipDashboardmflm;


const LeadershipDashboardmflm: React.FC = () => {
  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);

  // ✅ Extract token from query and handle redirect
  useTokenFromQuery("/app/kpi_leadership_dashboard_FLM");

  // ✅ Fetch user details (hook now returns userData)
  const userData = useFetchUserDetails(
    setUserLocation,
    setHeaderUsername,
    setRefreshTime,
    API_BASE_URL,
    "LeadershipDashboardmflm"
  );

  // ✅ Automatically reset refresh time (2 AM logic)
  useResetRefreshTime(setRefreshTime);

  // ✅ Decode token to get user_id
  const user_id = getUserIdFromToken();

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="KPI Dashboard"
          userName={headerUsername}
          location={userLocation}
          refreshTime={refreshTime}
        />
        <LeadershipdataComp />
        <LeadershipTable userData={userData}  />
      </div>
    </div>
  );
};

export default LeadershipDashboardmflm;
